function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "Ellipse_72",
  x: 0,
  y: 0,
  width: 34,
  height: 34,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_73",
  "data-name": "Ellipse 73",
  cx: 8,
  cy: 8,
  r: 8,
  transform: "translate(0 -0.062)",
  fill: "#fff"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Group_1987",
  "data-name": "Group 1987",
  transform: "translate(-8 38) rotate(-90)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "matrix(0, 1, -1, 0, 38, 8)",
  filter: "url(#Ellipse_72)"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_72-2",
  "data-name": "Ellipse 72",
  cx: 8,
  cy: 8,
  r: 8,
  transform: "translate(9 22) rotate(-90)",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  id: "Mask_Group_1",
  "data-name": "Mask Group 1",
  transform: "translate(16 17.062)",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_4906",
  "data-name": "Path 4906",
  d: "M0,0H5V20H0Z",
  transform: "translate(0 -2.062)",
  fill: "#fcce04"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_76",
  "data-name": "Rectangle 76",
  width: 6,
  height: 20,
  transform: "translate(5 -2.062)",
  fill: "#dc0204"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_4907",
  "data-name": "Path 4907",
  d: "M0,0H5V20H0Z",
  transform: "translate(11 -2.062)",
  fill: "#000000"
})));

var SvgDe = function SvgDe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/de.919aca00.svg";
export { ForwardRef as ReactComponent };